import { Component } from '@angular/core';

@Component({
  selector: 'app-auth-layout',
  template: `
    <div>
      <router-outlet></router-outlet>
    </div>
  `,
  styles: [`
    .auth-layout {
      height: 100vh;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #f8f9fa;
    }
  `]
})
export class AuthLayoutComponent {} 